import { Box, Text } from '@chakra-ui/react';
import { TextCellProps } from '../types/Cell';

export const TextCell = ({
  label,
  textStyle = 'body.s.medium',
  maxWidth = '400px',
  lineClamp = 1,
  ...props
}: TextCellProps): React.ReactElement => {
  return (
    <Box maxWidth={maxWidth} position="relative" p="0 10px 0 0">
      <Text
        textStyle={textStyle}
        lineClamp={lineClamp}
        overflow="hidden"
        textOverflow="ellipsis"
        whiteSpace={lineClamp === 1 ? 'nowrap' : 'normal'}
        {...props}
      >
        {label}
      </Text>
    </Box>
  );
};
